/* istanbul ignore file */
/* tslint:disable */
 
import type { InsuredDetail } from '../models/InsuredDetail';
import type { InternalPolicyCreate } from '../models/InternalPolicyCreate';
import type { InternalPolicyDetail } from '../models/InternalPolicyDetail';
import type { PaginatedInsuredListList } from '../models/PaginatedInsuredListList';
import type { PaginatedPolicyListList } from '../models/PaginatedPolicyListList';
import type { PolicyDetail } from '../models/PolicyDetail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InsuranceService {

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns PaginatedInsuredListList 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesList(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
page?: number,
pageSize?: number,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<PaginatedInsuredListList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this insured.
   * @returns InsuredDetail 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesRetrieve(
id: number,
): CancelablePromise<InsuredDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesCsvRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/csv/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesGreenCardCsvRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/green-card-csv/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesGreenCardXlsxRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/green-card-xlsx/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesMedicalXlsxRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/medical-xlsx/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesRcaCsvRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/rca-csv/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesRcaXlsxRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/rca-xlsx/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param dateGte Filtrează entitățile asigurate cu data emiterii poliței mai mare sau egală decât valoarea transmisă.
   * @param dateLte Filtrează entitățile asigurate cu data emiterii poliței mai mică sau egală decât valoarea transmisă.
   * @param entity 
   * @param entitySearch Caută entitățile asigurate după nume, IDNP/IDNO, număr certificat, email sau număr de înmatriculare.
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude entitățile asigurate care au oricare dintre statusurile de comandă transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param number Filtrează entitățile asigurate după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: order__created, order__modified, order__product, order__policy__date, order__policy__number
   * @param policy Filtrează entitățile asigurate după ID-ul poliței.
   * @param product Filtrează entitățile asigurate după ID-urile produselor.
   * @param search Search fields: order__policy__number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name, entity__as_legalentity__identification_number, entity__as_legalentity__name, entity__as_person__email, entity__as_person__first_name, entity__as_person__last_name, entity__as_person__identification_number, entity__as_vehicle__certificate_number, entity__as_vehicle__registration_number
   * @param status Filtrează entitățile asigurate după statusul comenzii.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param user Filtrează entitățile asigurate după ID-ul utilizatorului.
   * @param validFromAfter Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validFromBefore Filtrează entitățile asigurate după intervalul datei de început a valabilității poliței.
   * @param validToAfter Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @param validToBefore Filtrează entitățile asigurate după intervalul datei de sfârșit a valabilității poliței.
   * @returns binary 
   * @throws ApiError
   */
  public static insuranceInsuredEntitiesXlsxRetrieve(
dateGte?: string,
dateLte?: string,
entity?: number,
entitySearch?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
number?: string,
order?: number,
ordering?: string,
policy?: number,
product?: Array<number>,
search?: string,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/insured-entities/xlsx/',
      query: {
        'date_gte': dateGte,
        'date_lte': dateLte,
        'entity': entity,
        'entity_search': entitySearch,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'policy': policy,
        'product': product,
        'search': search,
        'status': status,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param number 
   * @param requestBody 
   * @returns InternalPolicyDetail 
   * @throws ApiError
   */
  public static insuranceInternalPoliciesCreate(
number: string,
requestBody?: InternalPolicyCreate,
): CancelablePromise<InternalPolicyDetail> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/insurance/internal/policies/{number}/',
      path: {
        'number': number,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param customer Filtrează polițele după ID-ul clientului.
   * @param date 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param ids comma separated list
   * @param number Filtrează polițele după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: created, modified, order__product, number
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param product Filtrează polițele după ID-urile produselor.
   * @param search Search fields: number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name
   * @param user Filtrează polițele după ID-ul utilizatorului.
   * @param validFromAfter Filtrează polițele după intervalul datei de început a valabilității.
   * @param validFromBefore Filtrează polițele după intervalul datei de început a valabilității.
   * @param validToAfter Filtrează polițele după intervalul datei de sfârșit a valabilității.
   * @param validToBefore Filtrează polițele după intervalul datei de sfârșit a valabilității.
   * @returns PaginatedPolicyListList 
   * @throws ApiError
   */
  public static insurancePoliciesList(
customer?: number,
date?: string,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
ids?: string,
number?: string,
order?: number,
ordering?: string,
page?: number,
pageSize?: number,
product?: Array<number>,
search?: string,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<PaginatedPolicyListList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/policies/',
      query: {
        'customer': customer,
        'date': date,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'product': product,
        'search': search,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this policy.
   * @returns PolicyDetail 
   * @throws ApiError
   */
  public static insurancePoliciesRetrieve(
id: number,
): CancelablePromise<PolicyDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/policies/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param customer Filtrează polițele după ID-ul clientului.
   * @param date 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param ids comma separated list
   * @param number Filtrează polițele după numărul poliței, potrivire parțială.
   * @param order 
   * @param ordering Ordering fields: created, modified, order__product, number
   * @param product Filtrează polițele după ID-urile produselor.
   * @param search Search fields: number, order__user__email, order__user__first_name, order__user__last_name, order__anonymous__email, order__contractor__as_person__email, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_person__identification_number, order__contractor__as_legalentity__identification_number, order__contractor__as_legalentity__name
   * @param user Filtrează polițele după ID-ul utilizatorului.
   * @param validFromAfter Filtrează polițele după intervalul datei de început a valabilității.
   * @param validFromBefore Filtrează polițele după intervalul datei de început a valabilității.
   * @param validToAfter Filtrează polițele după intervalul datei de sfârșit a valabilității.
   * @param validToBefore Filtrează polițele după intervalul datei de sfârșit a valabilității.
   * @returns binary 
   * @throws ApiError
   */
  public static insurancePoliciesXlsxRetrieve(
customer?: number,
date?: string,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
ids?: string,
number?: string,
order?: number,
ordering?: string,
product?: Array<number>,
search?: string,
user?: number,
validFromAfter?: string,
validFromBefore?: string,
validToAfter?: string,
validToBefore?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insurance/policies/xlsx/',
      query: {
        'customer': customer,
        'date': date,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'ids': ids,
        'number': number,
        'order': order,
        'ordering': ordering,
        'product': product,
        'search': search,
        'user': user,
        'valid_from_after': validFromAfter,
        'valid_from_before': validFromBefore,
        'valid_to_after': validToAfter,
        'valid_to_before': validToBefore,
      },
    });
  }

}
